export default function usePurchaseOrder() {
  const en = ['PENDING', 'DONE', 'CANCELLED', 'PURCHASING'];
  const th = ['รออสั่งซื้อ', 'สำเร็จ', 'ยกเลิก', 'รอรับของ'];

  function statusTranslate(string: string, amount = -1, filled = -1, approved = true, managerApproved = true, chiefManagerApproved = true, totalPrice = 0) {
    if (string === 'CANCELLED') return 'ยกเลิก';
    if (string === 'DONE') return 'สำเร็จ';
    if (!approved) return 'รออนุมัติ';
    if (!managerApproved) return 'รอผู้จัดการอนุมัติ';
    if (!chiefManagerApproved) return 'รอผู้บริหารอนุมัติ';
    if ((string === 'PENDING' || string === 'PURCHASING') && amount !== -1 && filled !== -1) {
      if (filled >= amount) return 'สำเร็จ';
    }
    const index = en.indexOf(string);
    if (index > -1) return th[index];
    return '-';
  }

  const statusClassMap = (status: string, amount = -1, filled = -1, approved = true, managerApproved = true, chiefManagerApproved = true, totalPrice = 0) => {
    if (status === 'CANCELLED') return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-600';
    if (status === 'DONE') return 'block text-white rounded-xl text-xs py-1 text-center bg-green-600';
    if (!approved) return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-500';
    if (!managerApproved) return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
    if (!chiefManagerApproved) return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
    let resultStatus = status;
    if ((resultStatus === 'PENDING' || resultStatus === 'PURCHASING') && amount !== -1 && filled !== -1) {
      if (filled >= amount) resultStatus = 'DONE';
    }
    switch (resultStatus) {
      case 'PENDING':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'PURCHASING':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'DONE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-600';
      case 'CANCELLED':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-600';
      default: return '';
    }
  };

  return {
    en,
    th,
    statusTranslate,
    statusClassMap,
  };
}
